import { Form } from "react-router";
import { z } from "zod";
import { StatusButton } from "~/components/ui/status-button";
import { useIsPending } from "./misc";
import { Icon } from "~/components/ui/icon";

const typeToAction = {
  login: "Inicia sesión",
  signup: "Registrate",
  connect: "Conectate",
};

export const GOOGLE_PROVIDER_NAME = "google";
// to add another provider, set their name here and add it to the providerNames below

export const providerNames = [GOOGLE_PROVIDER_NAME] as const;
export const ProviderNameSchema = z.enum(providerNames);
export type ProviderName = z.infer<typeof ProviderNameSchema>;

export const providerLabels: Record<ProviderName, string> = {
  [GOOGLE_PROVIDER_NAME]: "Google",
} as const;

export const providerIcons: Record<ProviderName, React.ReactNode> = {
  [GOOGLE_PROVIDER_NAME]: <Icon name="google" />,
  // [GITHUB_PROVIDER_NAME]: <Icon name="github-logo" />,
} as const;

export const ProviderConnectionForm = ({
  redirectTo,
  type,
  providerName,
  withPrefix = true,
}: {
  redirectTo?: string | null;
  type: "connect" | "login" | "signup";
  providerName: ProviderName;
  withPrefix?: boolean;
}) => {
  const label = providerLabels[providerName];
  const formAction = `/auth/${providerName}`;
  const isPending = useIsPending({ formAction });
  return (
    <Form
      className="flex items-center justify-center gap-2"
      action={formAction}
      method="POST"
    >
      {redirectTo ? (
        <input type="hidden" name="redirectTo" value={redirectTo} />
      ) : null}
      <StatusButton
        type="submit"
        className="w-full"
        status={isPending ? "pending" : "idle"}
        size="lg"
      >
        <span className="inline-flex items-center gap-3 fill-primary-foreground">
          {providerIcons[providerName]}
          <span>
            {withPrefix ? `${typeToAction[type]} con ` : ""}
            {label}
          </span>
        </span>
      </StatusButton>
    </Form>
  );
};
